import {
  ADD_ITEM_PROJECT_NEW_GROUP,
  ADD_ITEM_PROJECT_W_NO_NEW_GROUP,
  BUTTON_SUBMISSION,
  EVENT_NAME_PREFIX_PROJECTS,
  MY_ACCOUNT_SETTINGS,
  ADD_ITEM_NEW_PROJECT_EVENT,
  ADD_ITEM_WITH_NEW_GROUP,
  ADD_ITEM_IN_EXISTING_GROUP,
  PROJECT_ADD_DELIVERY_ZIPCODE_MESSAGING_ERROR,
  ADD_DELIVERY_ZIP_CLICK,
  DELIVERY_ZIP_OVERLAY,
  DELIVERY_ZIPCODE_UPDATED,
  PROJECT_STORE_OVERLAY,
  SHOP_LOCATION_LINK_CLICK,
  SHOPPING_IN_LINK,
  OVERLAY,
  STASH,
  ERROR,
  PROJECT_SHOPPING_FOR_ERROR,
} from '../constants';
import { getPageType, getProjectAddTotal, getUniqueSkuCount } from '../thd-analytics-utils';

export const projectDetails = () => {
  const OVERVIEW_EDIT_FORM = 'projects: overview edit form';
  const EDIT_PROJECT_DETAILS = 'projects: project details:';
  const CREATE_GROUP = 'projects: create group';
  const GROUP_MODIFICATION = 'projects: group modification';
  const GROUP_ACCORDION_CLICK = 'projects: materials: group accordion click';
  const MATERIAL_TAB_SELECT_ALL = 'projects: materials: select all';
  const ADD_ITEM_OVERLAY = 'projects: add items overlay';
  const ADD_ITEM_OVERLAY_CLICK_TO_PIP = 'projects: add items overlay click to PIP';
  const ADD_ITEM_NEW_PROJECT = 'projects: add to project action to new project';
  const REMOVE_ITEM = 'projects: update remove';
  const DETAILS_COLLAB = 'projects: project details: collab';
  const PRODUCT_CLICK = 'projects: project details: product click';
  const DRAG_DROP = 'projects: project details: drag and drop';
  const BULK_MOVE_DRAG_DROP = 'projects: project details: bulk move: drag and drop';
  const BULK_MOVE_OVERLAY = 'projects: project details: bulk move: move materials overlay';
  const BULK_SORT_GROUP = 'projects: project details: bulk sort group';
  const ITEM_DETAILS_LINK = 'item details link';
  const EXPORT_PROJECTS= 'projects: download material list: successful download';
  const EXPORT_ERROR = 'projects: download material list: error';
  const ACTIVITY_LOG_CLICK = 'project-details.activity-log-tab-click';
  const TOGGLE_HIDING_ACTION_BAR = 'project-details.toggle-hide-action-bar';

  // 7.51.15 Edit Jobsite or Project info
  LIFE_CYCLE_EVENT_BUS.on(OVERVIEW_EDIT_FORM, ({ output }) => {
    const form = output?.form || '';
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS,
      },
      myAccount: {
        settings: `${EDIT_PROJECT_DETAILS}>${form}`,
      }
    };
    digitalData.event.push(ddoEvent);
  });

  // 7.51.16 Create a Group
  LIFE_CYCLE_EVENT_BUS.on(CREATE_GROUP, () => {
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: CREATE_GROUP,
      }
    };
    digitalData.event.push(ddoEvent);
  });

  // 1.5 Edit Project List Overlay
  LIFE_CYCLE_EVENT_BUS.on('project-details.edit-project-list', () => {
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: 'projects: edit project list',
      }
    };
    digitalData.event.push(ddoEvent);
  });

   // 1.5 Edit Project List Overlay
  LIFE_CYCLE_EVENT_BUS.on('project-details.edit-group-accordion', () => {
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: 'projects: edit group',
      }
    };
    digitalData.event.push(ddoEvent);
  });

  // 7.51.17 / 1.1.18 Create, edit, or delete a group (Materials tab or Edit Project List Overlay)
  LIFE_CYCLE_EVENT_BUS.on(GROUP_MODIFICATION, ({ output }) => {
    const groupAction = output?.groupAction || '';
    const source = output?.source || '';
    const settingsPrefix = source === 'edit-project-list-overlay'
      ? 'projects: edit project list overlay'
      : 'projects: materials: group';
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS,
      },
      myAccount: {
        settings: `${settingsPrefix}: ${groupAction}`,
      }
    };
    digitalData.event.push(ddoEvent);
  });

    LIFE_CYCLE_EVENT_BUS.on(GROUP_ACCORDION_CLICK, ({ output }) => {
    const groupAction = output?.groupAction || '';

    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS,
      },
      myAccount: {
        settings: `projects: materials: group accordion: ${groupAction}`,
      }
    };
    digitalData.event.push(ddoEvent);
  });

  // 7.51.18 Material tab select all
  LIFE_CYCLE_EVENT_BUS.on(MATERIAL_TAB_SELECT_ALL, () => {
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS,
      },
      myAccount: {
        settings: 'projects: materials: select all',
      }
    };
    digitalData.event.push(ddoEvent);
  });

  // 7.51.19 Add items overlay
  LIFE_CYCLE_EVENT_BUS.on(ADD_ITEM_OVERLAY, () => {
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: 'projects: add items to project',
      }
    };
    digitalData.event.push(ddoEvent);
  });

  // 7.51.21 Add items overlay click to PIP
  LIFE_CYCLE_EVENT_BUS.on(ADD_ITEM_OVERLAY_CLICK_TO_PIP, () => {
    const ddoEvent = {
      category: {
        primaryCategory: STASH
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS,
      },
      eventMode: STASH,
      stash: {
        myAccount: {
          settings: 'projects: add items to project overlay: click to pip',
        }
      }
    };
    digitalData.event.push(ddoEvent);
  });

  // 7.51.22 Add to Project action w/new Group created
  LIFE_CYCLE_EVENT_BUS.on(ADD_ITEM_WITH_NEW_GROUP, ({ output }) => {
    const page = getPageType();
    const location = EVENT_NAME_PREFIX_PROJECTS[page] ?? page;
    const {
      id, type, desc, address, zip, items = []
    } = output || {};
    const itemsFormatted = items.map((item) => ({
      quantity: item.quantity,
      projectLocation: location,
      price: {
        basePrice: item.price
      },
      productInfo: {
        sku: item.sku
      }
    }));

    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: ADD_ITEM_PROJECT_NEW_GROUP,
      },
      projectId: id,
      item: itemsFormatted,
      uniqueSkuCount: getUniqueSkuCount(items),
      projectAddTotal: getProjectAddTotal(items),
      myAccount: {
        settings: `projects: project created: type ${type}: desc ${desc}: address ${address}: zip ${zip}`,
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  // 7.51.29 Add to Project action w/NO new Group created
  LIFE_CYCLE_EVENT_BUS.on(ADD_ITEM_IN_EXISTING_GROUP, ({ output }) => {
    const page = getPageType();
    const {
      id, type, desc, address, zip, items = [], copyAnalytic
    } = output || {};
    let location = '';
    if (copyAnalytic === 'copy_from_project') {
      location = 'project details: copy from project';
    } else if (copyAnalytic === 'copy_from_list') {
      location = 'project details: copy from list';
    } else {
      location = EVENT_NAME_PREFIX_PROJECTS[page] ?? page;
    }
    const itemsFormatted = items.map((item) => ({
      quantity: item.quantity,
      projectLocation: location,
      price: {
        basePrice: item.price
      },
      productInfo: {
        sku: item.sku
      }
    }));
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: ADD_ITEM_PROJECT_W_NO_NEW_GROUP,
      },
      projectId: id,
      item: itemsFormatted,
      uniqueSkuCount: getUniqueSkuCount(items),
      projectAddTotal: getProjectAddTotal(items),
      myAccount: {
        settings: `projects: project created: type ${type}: desc ${desc}: address ${address}: zip ${zip}`,
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on(ADD_ITEM_NEW_PROJECT, ({ output }) => {
    const page = getPageType();
    const location = EVENT_NAME_PREFIX_PROJECTS[page] ?? page;
    const {
      id, type, desc, address, zip, items
    } = output || {};
    const itemsFormatted = items.map((item) => ({
      quantity: item.quantity,
      projectLocation: location,
      price: {
        basePrice: item.price
      },
      productInfo: {
        sku: item.sku
      }
    }));
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: ADD_ITEM_NEW_PROJECT_EVENT,
      },
      projectId: id,
      item: itemsFormatted,
      uniqueSkuCount: getUniqueSkuCount(items),
      projectAddTotal: getProjectAddTotal(items),
      myAccount: {
        settings: `projects: project created: type ${type}: desc ${desc}: address ${address}: zip ${zip}`,
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  // 7.51.23 Projects Update – Remove
  LIFE_CYCLE_EVENT_BUS.on(REMOVE_ITEM, ({ output }) => {
    const { id, itemsRemoved = [], settings = '' } = output || {};
    let items = [];
    // eslint-disable-next-line array-callback-return
    itemsRemoved.map((item, index) => {
      items.push({
        quantity: item.quantity,
        price: {
          basePrice: item.original * item.quantity
        },
        productInfo: {
          sku: item.sku
        }
      });
    });
    const ddoEvent = {
      category: {
        primaryCategory: 'project view modification'
      },
      eventInfo: {
        eventName: 'project remove',
      },
      projectId: id,
      item: items,
      myAccount: {
        settings
      }
    };
    digitalData.event.push(ddoEvent);
  });

  // 7.51.37 Collaborator View Project Details Actions
  LIFE_CYCLE_EVENT_BUS.on(DETAILS_COLLAB, ({ output }) => {
    const action = output?.action || '';
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION,
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS,
      },
      myAccount: {
        settings: `${DETAILS_COLLAB}: ${action}`,
      }
    };
    digitalData.event.push(ddoEvent);
  });

  // 7.51.38 Project Details: Click to PIP
  LIFE_CYCLE_EVENT_BUS.on(PRODUCT_CLICK, () => {
    const ddoEvent = {
      category: {
        primaryCategory: STASH
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS,
      },
      eventMode: STASH,
      stash: {
        myAccount: {
          settings: PRODUCT_CLICK
        }
      }
    };
    digitalData.event.push(ddoEvent);
  });

  // 7.51.43 Project Details: Tab Navigation
  LIFE_CYCLE_EVENT_BUS.on('project-details.tab-change', ({ output }) => {
    const { tabName = 'N/A' } = output || {};

    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS,
      },
      myAccount: {
        settings: `${EDIT_PROJECT_DETAILS} ${tabName} tab`
      }
    };
    digitalData.event.push(ddoEvent);
  });

  // 1.1.71 Activity Log Button Clicks
  LIFE_CYCLE_EVENT_BUS.on(ACTIVITY_LOG_CLICK, ({ output }) => {
    const tabName = output?.tabName ?? 'N/A'

    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS,
      },
      myAccount: {
        settings: `${EDIT_PROJECT_DETAILS} ${tabName} tab: activity log button click`
      }
    };
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on(TOGGLE_HIDING_ACTION_BAR, ({ output }) => {
    const value = output?.value ?? 'N/A'

    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS,
      },
      myAccount: {
        settings: `${EDIT_PROJECT_DETAILS} action bar: ${value}`
      }
    };
    digitalData.event.push(ddoEvent);
  });

  // 7.51.44 Quotes: Quote Name Link & Back to Project Details Link
  LIFE_CYCLE_EVENT_BUS.on('project-details.quote-name-link', ({ output }) => {
    const { message = 'N/A' } = output || {};

    const ddoEvent = {
      category: {
        primaryCategory: STASH
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS,
      },
      eventMode: STASH,
      stash: {
        myAccount: {
          settings: message
        }
      }
    };
    digitalData.event.push(ddoEvent);
  });

  // 7.51.45 Purchases Tab: Order Number Link
  LIFE_CYCLE_EVENT_BUS.on('project-details.purchase-number-link', ({ output }) => {
    const { message = 'N/A' } = output || {};

    const ddoEvent = {
      category: {
        primaryCategory: STASH
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS,
      },
      eventMode: STASH,
      stash: {
        myAccount: {
          settings: message
        }
      }
    };
    digitalData.event.push(ddoEvent);
  });

  // 7.51.42 Group Created, Deleted or Name Edited
  LIFE_CYCLE_EVENT_BUS.on(DRAG_DROP, ({ output }) => {
    const { options = 'N/A' } = output || {};
    const optionsDict = {
      'same-group': 'projects: materials: moved material: same group',
      'group-changed': 'projects: materials: moved material: group changed',
      'unassigned': 'projects: materials: moved material: unassigned group',
      'N/A': 'projects: materials: group not catched'
    }

    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS,
      },
      myAccount: {
        settings: optionsDict[options],
      }
    };
    digitalData.event.push(ddoEvent);
  });

  // Bulk Move: Drag and Drop
  LIFE_CYCLE_EVENT_BUS.on(BULK_MOVE_DRAG_DROP, () => {
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS,
      },
      myAccount: {
        settings: BULK_MOVE_DRAG_DROP,
      }
    };
    digitalData.event.push(ddoEvent);
  });

  // Bulk Move: Move Materials Overlay
  LIFE_CYCLE_EVENT_BUS.on(BULK_MOVE_OVERLAY, () => {
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS,
      },
      myAccount: {
        settings: BULK_MOVE_OVERLAY,
      }
    };
    digitalData.event.push(ddoEvent);
  });

  // Bulk Sort Group
  LIFE_CYCLE_EVENT_BUS.on(BULK_SORT_GROUP, () => {
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS,
      },
      myAccount: {
        settings: BULK_SORT_GROUP,
      }
    };
    digitalData.event.push(ddoEvent);
  });

  // 7.51.53  Add Delivery Zip Code messaging on Project Details Page
  LIFE_CYCLE_EVENT_BUS.on(PROJECT_ADD_DELIVERY_ZIPCODE_MESSAGING_ERROR, () => {
    const ddoEvent = {
      category: {
        primaryCategory: ERROR
      },
      eventInfo: {
        eventName: 'post page error',
        error: [
          {
            type: 'advisory',
            displayType: 'inline',
            pageSection: 'project details',
            message: 'project details page: add delivery zip code',
            code: 'n/a',
          }
        ]
      },
    };
    digitalData.event.push(ddoEvent);
  });

  // 7.51.53.7 “Shopping for” messaging on Project Details Page
  LIFE_CYCLE_EVENT_BUS.on(PROJECT_SHOPPING_FOR_ERROR, () => {
    const ddoEvent = {
      category: {
        primaryCategory: ERROR
      },
      eventInfo: {
        eventName: 'post page error',
        error: [
          {
            type: 'advisory',
            displayType: 'inline',
            pageSection: 'project details',
            message: 'project details page: shopping for project shop this location',
            code: 'n/a',
          }
        ]
      },
    };
    digitalData.event.push(ddoEvent);
  });

  // 7.51.53.1  Project Localization: Add Delivery Zip Link
  LIFE_CYCLE_EVENT_BUS.on(ADD_DELIVERY_ZIP_CLICK, () => {
    const ddoEvent = {
      category: {
        primaryCategory: STASH
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS,
      },
      eventMode: STASH,
      stash: {
        myAccount: {
          settings: 'projects: project details: add delivery zip code link'
        }
      }
    };
    digitalData.event.push(ddoEvent);
  });

  // 7.51.53.2  Project Zip Overlay
  LIFE_CYCLE_EVENT_BUS.on(DELIVERY_ZIP_OVERLAY, () => {
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: 'project zip',
      },
    };
    digitalData.event.push(ddoEvent);
  });

  // 7.51.53.3 Project Localization: Zip Code Updated Action
  LIFE_CYCLE_EVENT_BUS.on(DELIVERY_ZIPCODE_UPDATED, () => {
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS,
      },
      myAccount: {
        settings: 'projects: project zip overlay: zip code updated'
      }
    };
    digitalData.event.push(ddoEvent);
  });

  // 7.51.53.4  Project Localization: Shop this Location link
  LIFE_CYCLE_EVENT_BUS.on(SHOP_LOCATION_LINK_CLICK, () => {
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS,
      },
      myAccount: {
        settings: 'projects: project details: shop this location link'
      }
    };
    digitalData.event.push(ddoEvent);
  });

  // 7.51.53.5  Project Store Overlay
  LIFE_CYCLE_EVENT_BUS.on(PROJECT_STORE_OVERLAY, () => {
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: 'project store',
      },
    };
    digitalData.event.push(ddoEvent);
  });

  // 7.51.44 Quotes: Quote Name Link & Back to Project Details Link
  LIFE_CYCLE_EVENT_BUS.on(SHOPPING_IN_LINK, ({ output }) => {
    const { link = 'N/A' } = output || {};
    const linkDict = {
      'store': 'projects: project details: shopping in: store link',
      'zip code': 'projects: project details: shopping in: zip code link',
      'N/A': 'projects: project details: shopping in: link not caught'
    }

    const ddoEvent = {
      category: {
        primaryCategory: STASH
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS,
      },
      eventMode: STASH,
      stash: {
        myAccount: {
          settings: linkDict[link]
        }
      }
    };
    digitalData.event.push(ddoEvent);
  });

  // 7.51.57 Item Details Link
  LIFE_CYCLE_EVENT_BUS.on(ITEM_DETAILS_LINK, () => {
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS,
      },
      myAccount: {
        settings: 'projects: materials tab: item details link'
      }
    };
    digitalData.event.push(ddoEvent);
  });

  LIFE_CYCLE_EVENT_BUS.on(EXPORT_PROJECTS, () => {
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS,
      },
      myAccount: {
        settings: EXPORT_PROJECTS
      }
    };
    digitalData.event.push(ddoEvent);
  })

  LIFE_CYCLE_EVENT_BUS.on(EXPORT_ERROR, () => {
    const ddoEvent = {
      category: {
        primaryCategory: ERROR
      },
      eventInfo: {
        eventName: 'post page error',
      },
      error: [
        {
          type: 'error',
          displayType: 'inline',
          pageSection: 'project details',
          message: 'file couldn\'t be downloaded due to an error try again',
          code: 'n/a',
        }
      ]
    };
    digitalData.event.push(ddoEvent);
  });
  LIFE_CYCLE_EVENT_BUS.on('projects: materials tab: action bar', ({ output }) => {
    const { actionBar = 'N/A' } = output?.output || output || {};
    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS,
      },
      myAccount: {
        settings: `projects: materials tab: action bar: ${actionBar}`
      }
    };
    digitalData.event.push(ddoEvent);
  });

    // Project Comments Overlay Click Event
  LIFE_CYCLE_EVENT_BUS.on('project-comments.click', () => {
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: "project comments"
      }
    };
    digitalData.event.push(ddoEvent);
  });

  // Project Comments Edit Comments Event
  LIFE_CYCLE_EVENT_BUS.on('project-comments.edit-comments', ({ output }) => {
    const action = output?.action || '';

    const ddoEvent = {
      category: {
        primaryCategory: BUTTON_SUBMISSION
      },
      eventInfo: {
        eventName: MY_ACCOUNT_SETTINGS
      },
      myAccount: {
        settings: `projects: project comments: ${action} comment`
      }
    };
    digitalData.event.push(ddoEvent);
  });
};
